import { GLOBAL_REGION } from '~/shared/constants'
import type { IPrimaryRegion } from './index.h'

export const noRegionSelection = {
  id: 0,
  name: 'Not selected',
  alias: GLOBAL_REGION as string,
} as IPrimaryRegion
